<nz-table
  #table
  nzSize="small"
  [nzBordered]="true"
  nzShowPagination
  nzShowSizeChanger
  [nzPageSize]="20"
  [nzData]="versions$ | async"
  [nzPageSizeOptions]="[10, 20, 30, 40, 50]"
>
  <thead>
    <tr>
      <th nzWidth="1px">{{ 'LOT_EVENTS.HISTORY.VERSION' | translate }}</th>
      <th nzWidth="1px">{{ 'LOT_EVENTS.HISTORY.DATE' | translate }}</th>
      <th nzWidth="1px">{{ 'LOT_EVENTS.HISTORY.AUTHOR' | translate }}</th>
      <th>{{ 'LOT_EVENTS.HISTORY.DESCRIPTION' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let v of table.data">
      <td nzAlign="center">{{ v.versionNumber }}</td>
      <td class="no-wrap" nzAlign="center">
        {{ v.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}
      </td>
      <td class="no-wrap">
        <a
          *ngIf="v.author"
          target="__blank"
          [href]="managerDomain + '/akebono-auctioneer/users/edit/' + v.author.id"
        >
          {{ v.author.fullName }}
          ({{ v.author.username }})
          <nz-tag *ngIf="v?.author?.countryIso">
            {{ getUserCountryName(v?.author?.countryIso) }}
          </nz-tag>
        </a>
        <span *ngIf="!v.author">System</span>
      </td>

      <td *ngIf="!rawView">
        <section *ngIf="v.versionNumber === 1">
          {{ 'LOT_EVENTS.HISTORY.CHANGES.CREATED' | translate }}
        </section>
        <section *ngIf="v.versionNumber !== 1">
          <ng-container *ngFor="let change of v.changeset$ | async">
            <div [ngSwitch]="change.key">
              <span *ngSwitchCase="'akebono_lot_translations_count'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.TRANSLATIONS_COUNT' | translate }}
                <nz-tag>{{ change.value }}</nz-tag>
              </span>
              <span *ngSwitchCase="'icons'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.ICONS' | translate }}
                <nz-tag>[{{ extractIcons(change.value) }}]</nz-tag>
              </span>
              <span *ngSwitchCase="'vin'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.VIN' | translate }}
                <nz-tag>{{ change.value }}</nz-tag>
              </span>
              <span *ngSwitchCase="'production_date'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.PRODUCTION_DATE' | translate }}
                <nz-tag>{{ change.value | date: 'yyyy-MM-dd' }}</nz-tag>
              </span>
              <span *ngSwitchCase="'photos_fetched'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.PHOTOS_FETCHED' | translate }}
              </span>
              <span *ngSwitchCase="'status'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.STATUS' | translate }}
                <nz-tag>
                  {{ 'LOT_STATUSES.' + lotStatuses[change.value] | uppercase | translate }}
                </nz-tag>
              </span>
              <span *ngSwitchCase="'images'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.IMAGES' | translate }}
                <nz-tag>{{ extractImages(change.value).length }}</nz-tag>
              </span>
              <span *ngSwitchCase="'thumbnails'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.THUMBNAILS' | translate }}
                <nz-tag>{{ extractImages(change.value).length }}</nz-tag>
              </span>
              <span *ngSwitchCase="'updated_at'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.UPDATED' | translate }}
              </span>
              <span *ngSwitchCase="'start_price_num'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.START_PRICE' | translate }}
                <nz-tag>{{ change.value ?? 0 }}¥</nz-tag>
              </span>
              <span *ngSwitchCase="'sold_price'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.SOLD_PRICE' | translate }}
                <nz-tag>{{ change.value ?? 0 }}¥</nz-tag>
              </span>
              <span *ngSwitchCase="'negotiations_price'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.NEGOTIATIONS_PRICE' | translate }}
                <nz-tag>{{ change.value ?? 0 }}¥</nz-tag>
              </span>
              <span *ngSwitchCase="'auction_datetime'">
                {{ 'LOT_EVENTS.HISTORY.CHANGES.AUCTION_DATETIME' | translate }}
                <nz-tag>{{ change.value | date: 'yyyy-MM-dd HH:mm' }}</nz-tag>
              </span>
              <span *ngSwitchDefault>
                {{ change.key }}:
                <nz-tag>{{ change.value }}</nz-tag>
              </span>
            </div>
          </ng-container>
        </section>
      </td>

      <td *ngIf="rawView">
        <ngx-json-viewer [json]="v.changeset" [expanded]="false"></ngx-json-viewer>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-row class="mode-switch" nzJustify="end">
  <nz-col>
    <nz-switch
      [(ngModel)]="rawView"
      nzCheckedChildren="raw"
      nzUnCheckedChildren="normal"
    ></nz-switch>
  </nz-col>
</nz-row>
